// frontend/src/components/shared/GlobalLoadingIndicator.tsx

import { useIsFetching } from '@tanstack/react-query';
import NProgress from 'nprogress';
import { useEffect } from 'react';
import { useNavigation } from 'react-router-dom';

export function GlobalLoadingIndicator() {
  const navigation = useNavigation();
  // Only count queries that don't have excludeFromGlobalLoading meta flag
  const isFetching = useIsFetching({
    predicate: (query) => !query.meta?.excludeFromGlobalLoading,
  });

  useEffect(() => {
    NProgress.configure({ showSpinner: false });

    // Start NProgress if there's a navigation event OR a data fetch is in progress.
    if (navigation.state !== 'idle' || isFetching > 0) {
      NProgress.start();
    } else {
      // Done when navigation is idle AND there are no active fetches.
      NProgress.done();
    }
  }, [navigation.state, isFetching]);

  return null;
}
